module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight--dark-dcf5e6054740582c40551cbef3e277ad.png";